import React from 'react';
import { Dropdown, Space } from 'antd';
import { Link } from 'react-router-dom';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'


// dropdown data
const items = [
  {
    label: <Link to="#" className='dropdown-menu-1'>SWITCH PROFILE TO</Link>,
    key: '0',
    className: 'dropdowm-menu-toggle'
  },
  {
    label: <Link to="/" className='dropdown-menu-2'>Attendant</Link>,
    key: '1',
    className: 'dropdowm-menu-toggle-2'
  },
  {
    type: 'divider',
  },
  {
    label: <Link to="/owner/dashboard" className='dropdown-menu-2'>Owner</Link>,
    key: '3',
    className: 'dropdowm-menu-toggle-2'
  },
];


const SidebarDropdownLayout = ({userInitials, userName, role}) => (
  <Dropdown
    menu={{
      items,
    }}
    trigger={['click']}
    className='dropdown'
  >
    <Link onClick={(e) => e.preventDefault()}>

        <Space className='gap-7'>
          <div className='flex'>
              <p className='user-initials'>{userInitials}</p>
              <div className='active-user mt-8'></div>
          </div>
          <div className='gap-1.5 flex flex-col'>
              <p className='username'>{userName}</p>
              <div className='user-type-flag'>
                  {role}
              </div>
          </div> 
          <ActiveIcon className="ml-7"/>
        </Space>
      
    </Link>

  </Dropdown>
);
export default SidebarDropdownLayout;